import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface Rule {
  details: string | ReactNode
  reason: string | ReactNode
  summary: string | ReactNode
}

const RuleBox: React.FC<Rule> = (props) => {
  const { summary, details, reason } = props
  return (
    <Box display="flex" flexDirection="column" padding={1}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body1">{summary}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box display="flex" flexDirection="column">
            <Box display="flex" flexDirection="column" padding={1}>
              <Typography variant="caption">Details</Typography>
              <Typography component="div" variant="body1">
                {details}
              </Typography>
            </Box>
            <Box display="flex" flexDirection="column" padding={1}>
              <Typography variant="caption">Reason</Typography>
              <Typography component="div" variant="body1">
                {reason}
              </Typography>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

export { RuleBox }
export type { Rule }
